export default __webpack_public_path__ + "static/media/2.af533d40.png";